<template>
  <div>
    <vx-card class="mb-4">
      <vs-tabs :color="colorx">
        <vs-tab :label="$t('product.title')">
          <validation-observer ref="validator" #default="{valid}">
            <div class="flex flex-col gap-4 mt-1">
              <div class="flex flex-col gap-2">
                <div class="w-full">
                  <div class="form-group">
                    <div class="mb-1">
                      <validation-provider
                          #default="{ errors }"
                          :name="$t('product.status')"
                          rules="required"
                          class="flex-grow"
                          slim>
                        <b-form-group
                          :label="$t('product.status')"
                          label-for="status">
                            <b-form-radio-group
                              id="status"
                              v-model="model.status"
                              name="status"
                              :options="statusList"
                              class="required mr-2"/>
                            <small class="text-danger">{{ errors[0] }}</small>
                            <!-- Só "Liberado" publica; os outros três são indistinguíveis para
                                 quem está cadastrando sem essa legenda. -->
                            <small class="text-muted d-block mt-1">
                              <strong>Liberado</strong> é o único status visível na busca do aluno e que pode ser
                              comprado. <strong>Criando</strong> e <strong>Editando</strong> mantêm o produto
                              invisível enquanto você monta o cadastro; <strong>Inativo</strong> tira da venda um
                              produto que já esteve liberado.
                            </small>
                        </b-form-group>
                    </validation-provider>
                      <!--
                      <vs-radio v-model="model.status"
                                vs-name="status"
                                v-for="item in statusList"
                                :key="item.value"
                                :label="item.text"
                                :vs-value="item.value"
                                class="mr-2">{{item.text}}</vs-radio>
                        -->
                    </div>
                  </div>
                </div>

                <div class="w-full">
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('responsible_entity')"
                    rules="required"
                    class="flex-grow"
                    slim>
                    <select-suggestion
                      id="legal_entity_id"
                      column="company_name,trading_name,cnpj"
                      model="LegalEntity"
                      v-model="legalEntity"
                      :label="$t('responsible_entity')"
                      :appendClearOption="false"
                      :placeholderText="pessoaJuridicaLocked ? '' : 'Digite o nome do estabelecimento'"
                      :itemTextFormat="legalEntityItemTextFormat"
                      :isDisabled="pessoaJuridicaLocked"
                      :required="true"
                    />
                    <!-- Vindo do cadastro de um plano, o responsável já está
                         decidido: o vínculo produto↔plano exige a mesma entidade
                         (validateProductItemLegalEntity), então deixar editar
                         seria oferecer uma escolha que o save vai recusar. -->
                    <small v-if="planIdFromQuery" class="text-muted d-block">
                      {{ $t('product.entity_locked_by_plan') }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </div>

                <div class="w-full grid grid-cols-3 gap-2">
                  <div class="flex col-span-2">
                    <validation-provider
                      #default="{ errors }"
                      :name="$t('product.name')"
                      rules="required"
                      class="flex-grow"
                      slim>
                      <b-form-group
                        :label="$t('product.name')"
                        label-for="product_name">
                        <b-form-input
                          id="product_name"
                          v-model="model.name"
                          :state="errors.length > 0 ? false:null"
                          name="product_name"
                          class="required"/>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                    <!--
                    <vs-input
                      id="product_name"
                      class="w-full required"
                      v-validate="'required|max:191'"
                      :label="$t('product.name')"
                      v-model="model.name"/>
                    <span class="text-danger text-sm" v-show="errors.has('name')">{{errors.first('name')}}</span>
                  -->
                  </div>

                  <div class="flex">
                    <validation-provider
                      #default="{ errors }"
                      :name="$t('product.price')"
                      rules="required"
                      class="flex-grow"
                      slim>
                      <!-- Com plano de assinatura na composição, este campo é o
                           valor da recorrência: é ele que vai ao gateway e é ele
                           que o aluno paga em cada ciclo. O rótulo muda para não
                           parecer preço de compra única. -->
                      <b-form-group
                        :label="subscriptionPlan ? $t('product.subscription_price') : $t('product.price')"
                        label-for="product_price">
                        <small v-if="subscriptionPlan" class="text-muted d-block mb-1">
                          {{ $t('product.subscription_price_help', { interval: (subscriptionPlan.interval_label || '').toLowerCase() }) }}
                        </small>
                        <money
                          id="product_price"
                          v-model="model.price"
                          v-bind="moneyMask"
                          :class="['form-control', 'required', { 'is-invalid': errors.length > 0 }]"
                          name="product_price"/>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>

                    <!--
                    <vx-input-group>
                      <vs-input
                        lang="pt-BR"
                        type="number"
                        v-model="model.price"
                        :label="$t('product.price')"
                        v-validate="'required|numeric'"
                        class="required"/>
                        <template slot="prepend">
                          <div class="append-text btn-addon flex items-end">
                              <span class="input-group-text-left includeIcon includeIconOnly vs-component">R$</span>
                            </div>
                        </template>
                      </vx-input-group>
                      -->
                    </div>

                </div>

                <!-- O registro no gateway de recorrência deixou de ser opcional:
                     era possível publicar um plano pago com o registro desligado,
                     e o aluno só descobria no fim do checkout — com o cartão já
                     cobrado. Agora todo plano com preço é registrado ao salvar, e
                     aqui só resta dizer em que estado ele está. -->
                <div class="w-full mt-2" v-if="subscriptionPlan">
                  <b-form-group :label="$t('subscription_plan.register_on_payment_gateway')">
                    <small class="text-muted d-block mb-1">{{ $t('subscription_plan.register_on_payment_gateway_help') }}</small>
                    <b-badge :variant="gatewayStatus.variant">{{ gatewayStatus.label }}</b-badge>
                    <!-- "Deve registrar" e "está registrado" são estados
                         diferentes: um plano pago cujo provisionamento falhou
                         precisa aparecer como pendente, e não como registrado. -->
                    <small v-if="gatewayStatus.hint" class="d-block mt-1" :class="gatewayStatus.hintClass">
                      {{ gatewayStatus.hint }}
                    </small>
                  </b-form-group>
                  <small class="text-muted d-block">
                    {{ $t('product.subscription_plan_linked', { name: subscriptionPlan.name }) }}
                  </small>
                </div>

                <div class="w-full">
                  <label class="text-sm pl-1">{{ $t('product.description') }}</label>
                  <ComplexEditor
                    v-bind:editor_data.sync="model.description"/>
                </div>

                <div class="w-full">
                  <label class="text-sm pl-1">{{ $t('product.how_works') }}</label>
                  <ComplexEditor
                    v-bind:editor_data.sync="model.how_works"/>
                </div>

                <div class="w-full">
                  <label class="text-sm pl-1">{{ $t('product.guidelines') }}</label>
                  <ComplexEditor
                    v-bind:editor_data.sync="model.guidelines"/>
                </div>
              </div>
              <div class="w-full flex gap-2 justify-end">
                <b-button
                  v-if="!isEdit()"
                  variant="primary"
                  :disabled="!validateForm"
                  v-permission="'products.create'"
                  @click="createOrUpdate">
                  {{ $t('action.save') }}
                </b-button>
                <b-button
                  v-if="isEdit()"
                  variant="primary"
                  :disabled="!validateForm"
                  v-permission="'products.edit'"
                  @click="createOrUpdate">
                  {{ $t('action.save') }}
                </b-button>

                <b-button
                  variant="outline-secondary"
                  @click="goBack">
                  <feather-icon
                    icon="CornerUpLeftIcon"
                    class="mr-50"/>
                  <span class="align-middle">{{$t('back')}}</span>
                </b-button>
              </div>
            <div class="flex flex-wrap items-center" v-if="isEdit()">
                <vue-dropzone
                  id="upload"
                  ref="fileUploadZone"
                  v-on:vdropzone-success="successSendFile"
                  v-on:vdropzone-sending="sending"
                  v-on:vdropzone-error="error"
                  v-on:vdropzone-file-added="added"
                  v-on:vdropzone-queue-complete="complete"
                  :use-font-awesome="true"
                  :options="dropzoneOptions"
                  :use-custom-dropzone-options="true"
                  :useCustomSlot="true"
                  style="width: 100%; margin-bottom: 10px">
                  <div class="dropzone-custom-content">
                    <h3 class="dropzone-custom-title">
                      {{ $t('messages.drag_and_drop_file') }}
                    </h3>
                    <div class="subtitle">
                      {{ $t('messages.or_select_file_in_computer') }}
                    </div>
                    <div class="subtitle">
                      Tamanho recomendado para imagens: 1200×675px (paisagem, 16:9) — é a foto usada nos cards e na página de detalhes da aula, plano ou local relacionado a este produto, quando cadastrada.
                    </div>
                  </div>
                </vue-dropzone>
              </div>
              <!-- isEdit() com parênteses: a referência ao método era sempre
                   truthy e a lista renderizava (vazia) também na criação. -->
              <div class="mt-2 w-full " v-if="isEdit()">
                <media-list :medias="files"
                            :show-delete="true"
                            @deleteMedia="deleteFile"
                            :action-on-click="false" />
              </div>
            </div>
         </validation-observer>
        </vs-tab>
        <vs-tab :label="$t('product.composition_prod')" v-if="isEdit()">
          <div class="vx-row mb-2 mt-1">
            <div class="vx-col w-full">
              <FormProductItem :id="id" :status="model.status"/>
            </div>
          </div>
        </vs-tab>
        <vs-tab :label="$t('cancellation.product_policy_tab')" v-if="isEdit()">
          <div class="vx-row mb-2 mt-1">
            <div class="vx-col w-full">
              <ProductPolicySection :product-id="id"/>
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
    </vx-card>
  </div>
</template>

<script>

import standard from '@/services/standard'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import {
  BForm,
  BButton,
  BFormGroup,
  BInputGroup,
  BFormTextarea,
  BCardText,
  BFormInput,
  BLink,
  BFormRadioGroup,
  BBadge
} from 'bootstrap-vue'

import { isAdmin } from '@/util/Util'
import { extend, localize } from 'vee-validate'
import { defineRule } from 'vee-validate';
import { Money } from 'v-money'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, min, max} from '@validations'

import SelectSuggestion from '@/components/SelectSuggestion.vue'
import ComplexEditor from '@/components/ComplexEditor.vue'
import MediaList from '@/components/media/MediaList.vue'

import FormProductItem from './FormProductItem.vue'
import ProductPolicySection from '@/views/apps/cancellation/ProductPolicySection.vue'

import ProductService from '@/services/api/ProductService'
import SubscriptionPlanService from '@/services/api/SubscriptionPlanService'
import { mapGetters } from 'vuex'


export default {
  directives: {

  },
  components: {
    SelectSuggestion,
    BForm,
    BButton,
    BFormGroup,
    BInputGroup,
    BFormTextarea,
    BCardText,
    BFormInput,
    BFormRadioGroup,
    BLink,
    BBadge,
    //
    ValidationProvider,
    ValidationObserver,
    SelectSuggestion,
    ComplexEditor,
    MediaList,
    vueDropzone: vue2Dropzone,
    FormProductItem,
    ProductPolicySection,
    Money,
  },
  props: {
    id: {
      default: null,
      type: Number
    }
  },

  data: () => ({
    service: null,
    dropzoneOptions: {},
    files: [],
    statusList: [
      { text: 'Criando', value: 'CR' },
      { text: 'Editando', value: 'ED' },
      { text: 'Liberado', value: 'RE' },
      { text: 'Inativo', value: 'DI' },
    ],
    model: {
      id: null,
      name : '',
      price : '',
      status: '',
      description: '',
      how_works: '',
      guidelines: '',
      legal_entity_id: null
    },
    legalEntity: null,
    /** Plano de assinatura na composição, se houver. Vem do próprio GET do produto. */
    subscriptionPlan: null,
    /** Só leitura: o backend decide o registro pelo preço, a tela apenas informa. */
    registerOnGateway: false,
    /** Se o plano realmente existe no gateway ativo (tem external id lá). */
    gatewayRegistered: false,
    originalPrice: null,
    priceChangeConfirmed: false,
    // <input type="number"> engole a vírgula decimal do pt-BR (digitar "199,90"
    // vira "19990" — preço 100x maior). `masked: false` faz o <money> emitir
    // number puro no v-model; a máscara visual usa vírgula/ponto como o Brasil.
    moneyMask: {
      decimal: ',',
      thousands: '.',
      prefix: 'R$ ',
      precision: 2,
      masked: false
    },
  }),
  computed: {
    ...mapGetters('dataAccess', ['activeEntity', 'entities', 'loaded', 'globalInstitutionLocked']),
    /**
     * Três estados, não dois. `register_on_payment_gateway` diz se o plano
     * *deve* estar no gateway (é derivado do preço); `gateway_registered` diz se
     * ele *está*. Quando o provisionamento falha os dois discordam, e era esse o
     * caso que aparecia como "Registrado" — mentira que só se descobria quando
     * um aluno tentava comprar.
     */
    gatewayStatus() {
      if (!this.registerOnGateway) {
        return {
          variant: 'secondary',
          label: this.$t('subscription_plan.gateway_not_applicable'),
          hint: null
        }
      }

      if (this.gatewayRegistered) {
        return {
          variant: 'success',
          label: this.$t('subscription_plan.gateway_registered'),
          hint: null
        }
      }

      return {
        variant: 'warning',
        label: this.$t('subscription_plan.gateway_pending'),
        hint: this.$t('subscription_plan.gateway_pending_help'),
        hintClass: 'text-warning'
      }
    },
    validateForm() {
      return !this.isEmpty(this.model.status)
              && !this.isEmpty(this.model.name)
              && !this.isEmpty(this.model.price)
              && !this.isEmpty(this.legalEntity)
    },
    /**
     * Quem só tem uma entidade (o caso do profissional autônomo) não escolhe
     * nada de fato — só preenche um campo de busca por um valor já decidido.
     * Trava o campo nesses casos, em vez de deixar parecer uma escolha real.
     */
    pessoaJuridicaLocked() {
      // Vindo de um plano, o responsável é o do plano e não se discute: o item
      // SPL só pode ser vinculado a produto da mesma pessoa jurídica.
      return !!this.planIdFromQuery
        || this.globalInstitutionLocked
        || (Array.isArray(this.entities) && this.entities.length === 1)
    },
    /** Veio de "Criar produto para este plano", no cadastro do plano. */
    planIdFromQuery() {
      return this.$route.query.subscription_plan_id || null
    }
  },
  beforeMount() {
    this.service = ProductService.build(this.$vs)

    this.dropzoneOptions = {
      url: `${process.env.VUE_APP_API_BASE_URL}/api/v1/products/${this.id}/files`,
      thumbnailWidth: 150,
      addRemoveLinks: true,
      createImageThumbnails: true,
      timeout: 180000,
      //maxFiles: 1,
      headers: { Authorization: `Bearer ${standard.token()}` },
      acceptedFiles: null
    }
  },
  async mounted() {
    if (!this.loaded) {
      await this.$store.dispatch('dataAccess/setupFromLogin')
    }

    // Antes do prefill genérico: o plano é a fonte mais específica e não pode
    // ser sobrescrita pela entidade ativa do menu, que pode ser outra.
    if (this.planIdFromQuery) {
      await this.adoptLegalEntityFromPlan()
    }

    this.prefillLegalEntity()

    if (this.id) {
      this.loadData(this.id)
    }
  },

  methods: {
    legalEntityItemTextFormat(model) {
      const trading = model?.trading_name || ''
      const company = model?.company_name || ''
      const label = trading && company ? `${trading} - ${company}` : (trading || company)
      return label || model?.name || `ID: ${model?.id}`
    },
    /**
     * Copia o responsável do plano que originou este produto.
     *
     * `validateProductItemLegalEntity` recusa vincular um plano a produto de
     * outra pessoa jurídica, então deixar o campo aberto aqui seria oferecer uma
     * escolha que o save vai recusar — e o vínculo automático pós-save falharia
     * em silêncio, deixando o plano invisível na vitrine.
     */
    async adoptLegalEntityFromPlan() {
      try {
        const plan = await SubscriptionPlanService.build(this.$vs).read(this.planIdFromQuery)
        if (plan && plan.legal_entity) {
          this.legalEntity = plan.legal_entity
        } else if (plan && plan.legal_entity_id) {
          const match = (this.entities || []).find(entity => entity.id === plan.legal_entity_id)
          this.legalEntity = match || { id: plan.legal_entity_id, trading_name: '', company_name: '' }
        }
      } catch (error) {
        this.notifyErrors(this.$vs, error)
      }
    },
    prefillLegalEntity() {
      if (this.legalEntity || this.id) {
        return
      }

      if (this.activeEntity) {
        this.legalEntity = {
          id: this.activeEntity.id,
          trading_name: this.activeEntity.name || '',
          company_name: ''
        }
        return
      }

      if (Array.isArray(this.entities) && this.entities.length === 1) {
        const [entity] = this.entities
        this.legalEntity = {
          id: entity.id,
          trading_name: entity.trading_name || entity.name || '',
          company_name: entity.company_name || ''
        }
      }
    },
    requiredClass(whichData) {
      return !this.isEmpty(whichData) ? 'w-full' : 'w-full required'
    },
    loadData(id) {
      this.$vs.loading()

      this.service.read(id).then(
        response => {
          this.model = response
          this.files = response.files
          this.subscriptionPlan = response.subscription_plan || null
          this.registerOnGateway = !!(response.subscription_plan && response.subscription_plan.register_on_payment_gateway)
          this.gatewayRegistered = !!(response.subscription_plan && response.subscription_plan.gateway_registered)
          this.originalPrice = response.price === null || response.price === undefined ? null : Number(response.price)
          this.priceChangeConfirmed = false

          if (response.legal_entity) {
            this.legalEntity = response.legal_entity
          } else if (response.legal_entity_id) {
            const match = (this.entities || []).find(entity => entity.id === response.legal_entity_id)
            this.legalEntity = match || {
              id: response.legal_entity_id,
              trading_name: '',
              company_name: ''
            }
          }
        },
        error => {
          this.$vs.loading.close()
        }
      ).finally(
        () => {
          this.$vs.loading.close()
        }
      )
    },
    createOrUpdate() {
      if (!this.legalEntity || !this.legalEntity.id) {
        this.notifyError(
          this.$vs,
          'Selecione uma pessoa jurídica antes de salvar o produto.'
        )
        return
      }

      // Repreçar assinatura não é uma edição comum: no PagBank o valor novo vale
      // também para quem já assinou, na próxima fatura. Perguntar antes é mais
      // honesto do que deixar o clube descobrir pelo extrato do aluno. Quem
      // decide se a confirmação é mesmo necessária é o backend, que sabe quantos
      // assinantes vivos existem — aqui só não deixamos passar em silêncio.
      if (this.needsPriceChangeConfirmation()) {
        this.confirmPriceChange()
        return
      }

      this.$vs.loading()

      // `id` (prop, vindo da rota) e não `model.id`: create -> edit reaproveita esta
      // mesma instância do componente (mesma rota-componente), então mounted() não
      // roda de novo e model.id ficaria preso em null, fazendo o próximo Salvar
      // criar um produto novo em vez de atualizar o recém-criado.
      const wasEdit = this.isEdit()

      const modelData = {
        id: this.id,
        name: this.model.name,
        price: this.model.price,
        status: this.model.status,
        description: this.model.description,
        how_works: this.model.how_works,
        guidelines: this.model.guidelines,
        legal_entity_id: this.legalEntity.id,
        // O backend recusa mudar o preço de um produto com assinante vivo sem
        // este aceite: no PagBank, repreçar altera o valor das assinaturas que
        // já existem. Quem confirmou no diálogo chega aqui com a flag ligada.
        confirm_price_change: this.priceChangeConfirmed,
        // `register_on_payment_gateway` não é mais enviado: o backend deriva o
        // registro do preço a cada save do produto.
      }

      this.service.createOrUpdate(modelData).then(
        data => {
          this.notifySuccess(this.$vs, this.$t('messages.success'))
          // O save deu certo, mas o registro do plano no gateway pode ter
          // falhado — e falhar em silêncio deixava o clube achando que tinha um
          // plano vendável. O produto fica salvo de qualquer forma: perder a
          // edição por causa do gateway seria pior.
          if (data.gateway_registration_warning) {
            this.notifyWarning(this.$vs, data.gateway_registration_warning, 10000)
          }
          // Produto criado a partir de um plano: vincula sozinho. Sem isto o
          // clube teria de lembrar de voltar ao plano para fazer o vínculo, e é
          // justamente esse passo esquecido que deixa o plano invisível na
          // vitrine — ele não passa no filtro que exige produto liberado.
          if (!wasEdit && this.planIdFromQuery) {
            this.attachPlanFromQuery(data.id)
          }
          if (data.status === 'RE') {
            this.warnIfPublishedWithoutItems(data.id)
          }
          if (wasEdit) {
            this.$router.push('/products')
          } else {
            this.$router.push(`/products/${data.id}/edit`)
          }
        },
        error => {
          this.showErrors(this.$validator, error)
          this.notifyError(
            this.$vs,
            this.$t('messages.error')
          )
        }
      ).finally(
        () => { this.$vs.loading.close() }
      )
    },
    attachPlanFromQuery(productId) {
      // `{form: ...}` porque o controller lê `request('form')` — mesmo envelope
      // que a aba de composição usa.
      this.service.addProductItem(productId, { form: { type: 'SPL', model_id: Number(this.planIdFromQuery) } })
        .catch(error => this.notifyErrors(this.$vs, error))
    },
    needsPriceChangeConfirmation() {
      return !!this.subscriptionPlan
        && !this.priceChangeConfirmed
        && this.originalPrice !== null
        && Number(this.model.price) !== Number(this.originalPrice)
    },
    confirmPriceChange() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: this.$t('product.price_change_title'),
        acceptText: this.$t('product.price_change_accept'),
        cancelText: 'Cancelar',
        text: this.$t('product.price_change_warning'),
        accept: () => {
          this.priceChangeConfirmed = true
          this.createOrUpdate()
        },
      })
    },
    // "Liberado" (RE) é o status que publica o produto, mas um produto sem
    // nenhum item em "Composição do produto" fica publicado e invisível ao
    // mesmo tempo — a vitrine descarta quem não tem item. Nada avisava disso.
    warnIfPublishedWithoutItems(productId) {
      this.service.getItems(productId).then(items => {
        if (!Array.isArray(items) || items.length > 0) {
          return
        }

        this.notifyWarning(
          this.$vs,
          'Produto liberado, mas ainda sem nenhum item em "Composição do produto" — ' +
          'ele só aparece no marketplace depois de adicionar pelo menos um.',
          8000
        )
      }).catch(() => {})
    },
    successSendFile(file, data) {
      this.files.push(data)
      this.notifySuccess(this.$vs, this.$t('messages.success'))
      //remove file trash
      this.$refs.fileUploadZone.removeAllFiles()
    },
    deleteFile(media) {
      this.$vs.loading()

      this.service.deleteFile(this.id, media.id).then(
        data => {
          this.notifySuccess(this.$vs, this.$t('messages.success'))
          this.files = data
        },
        error => {
          this.showErrors(this.$validator, error)
          this.notifyError(
            this.$vs,
            this.$t('messages.error')
          )
        }
      ).finally(
        () => { this.$vs.loading.close() }
      )
    },
    goBack() {
      this.$router.push('/products')
    },
    isAdmin() {
      return isAdmin()
    },
    isEdit() {
      return !_.isNil(this.id)
    }
  }
}
</script>

<style>
.input-group-text-left {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: .375rem .75rem;
    margin-bottom: 0;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    text-align: center;
    white-space: nowrap;
    background-color: #e9ecef;
    border: 1px solid #eee;
    border-radius: 5px;
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }

</style>
